import { dashboardApi } from "./dashboardApi";
import { dashboardTypes } from "./dashboardTypes";

const onGetUserEvents = (userId, timeZone) => async dispatch => {
  let response = await dashboardApi.getUserEvents(userId, timeZone);
  return response;
};

const onAddUpdateEvents = eventData => async dispatch => {
  let response = await dashboardApi.addUpdateEvents(eventData);
  return response;
};
const onDeleteUserEvents = eventId => async dispatch => {
  let response = await dashboardApi.deleteUserEvent(eventId);
  return response;
};
const onGetEmail =
  (userId, cursorDate = "", cursorId = "", direction = "", pageNumber) =>
  async dispatch => {
    let response = await dashboardApi.getEmails(
      userId,
      cursorDate,
      cursorId,
      direction,
      pageNumber,
    );
    return response;
  };

const onSendEmail = emailData => async dispatch => {
  let response = await dashboardApi.sendEmail(emailData);
  return response;
};
const onGetUserTeamAvailability = userData => async dispatch => {
  let response = await dashboardApi.getUserTeamAvailability(userData);
  return response;
};

const onChange = (field, value) => {
  return dispatch => {
    dispatch({
      type: dashboardTypes.DASHBOARD_ONCHANGE,
      payload: { prop: field, value: value },
    });
  };
};

export const dashboardActions = {
  onGetUserEvents: onGetUserEvents,
  onAddUpdateEvents: onAddUpdateEvents,
  onDeleteUserEvents: onDeleteUserEvents,
  onGetEmail: onGetEmail,
  onSendEmail: onSendEmail,
  onGetUserTeamAvailability: onGetUserTeamAvailability,
  onChange: onChange,
};
